module.exports = __webpack_public_path__ + "assets/img/login-bg.ed07d900.png";